// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"fc9a9ff5","353":"07f02071","594":"0feeec17"}[chunkId] + ".chunk.css";
};